/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Prepare_Generating_BriefInputs */

const en_interview_prepare_generating_brief = /** @type {(inputs: Interview_Prepare_Generating_BriefInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generating brief...`)
};

const de_interview_prepare_generating_brief = /** @type {(inputs: Interview_Prepare_Generating_BriefInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bericht wird generiert...`)
};

const fr_interview_prepare_generating_brief = /** @type {(inputs: Interview_Prepare_Generating_BriefInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Génération de la fiche...`)
};

const es_interview_prepare_generating_brief = /** @type {(inputs: Interview_Prepare_Generating_BriefInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generando informe...`)
};

const it_interview_prepare_generating_brief = /** @type {(inputs: Interview_Prepare_Generating_BriefInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generazione scheda...`)
};

const nl_interview_prepare_generating_brief = /** @type {(inputs: Interview_Prepare_Generating_BriefInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notitie genereren...`)
};

const pl_interview_prepare_generating_brief = /** @type {(inputs: Interview_Prepare_Generating_BriefInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generowanie notatki...`)
};

const fi_interview_prepare_generating_brief = /** @type {(inputs: Interview_Prepare_Generating_BriefInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luodaan tiivistelmää...`)
};

const da_interview_prepare_generating_brief = /** @type {(inputs: Interview_Prepare_Generating_BriefInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genererer oversigt...`)
};

const sv_interview_prepare_generating_brief = /** @type {(inputs: Interview_Prepare_Generating_BriefInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genererar översikt...`)
};

/**
* | output |
* | --- |
* | "Generating brief..." |
*
* @param {Interview_Prepare_Generating_BriefInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_prepare_generating_brief = /** @type {((inputs?: Interview_Prepare_Generating_BriefInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Prepare_Generating_BriefInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_prepare_generating_brief(inputs)
	if (locale === "fr") return fr_interview_prepare_generating_brief(inputs)
	if (locale === "es") return es_interview_prepare_generating_brief(inputs)
	if (locale === "it") return it_interview_prepare_generating_brief(inputs)
	if (locale === "nl") return nl_interview_prepare_generating_brief(inputs)
	if (locale === "pl") return pl_interview_prepare_generating_brief(inputs)
	if (locale === "fi") return fi_interview_prepare_generating_brief(inputs)
	if (locale === "da") return da_interview_prepare_generating_brief(inputs)
	if (locale === "sv") return sv_interview_prepare_generating_brief(inputs)
	return en_interview_prepare_generating_brief(inputs)
});